// extracted by mini-css-extract-plugin
export default {"primaryBtn":"button_primaryBtn__uMk4S","secondaryBtn":"button_secondaryBtn__4xXAU"};